import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MobileMenu extends ThemeComponent {
    @Prop menu!: ShopifyLinklist;

    init() {

    }
}
